import { render, staticRenderFns } from "./amazingOffers.vue?vue&type=template&id=2d04b9ee&scoped=true&"
import script from "./amazingOffers.vue?vue&type=script&lang=js&"
export * from "./amazingOffers.vue?vue&type=script&lang=js&"
import style0 from "./amazingOffers.vue?vue&type=style&index=0&id=2d04b9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04b9ee",
  null
  
)

export default component.exports